<template>
  <div class="assembled-part-cost-estimator-form">
    <Form ref="assembledPartCostEstimatorForm" :model="formData">
      <FormItem :label="$t('title')" :rules="{ required: true, message: 'Title is required.' }" prop="title" required>
        <Input v-model="formData.title"></Input>
      </FormItem>
      <FormItem :label="$t('part.assembled_part')" prop="manufacturer_part_id" :rules="{ required: true, message: 'Assembled part is required.' }" required>
        <ManufacturerPartPicker
              :label="false"
              v-model="formData.manufacturer_part_id"
              :bomId.sync="formData.bom_id">
        </ManufacturerPartPicker>
      </FormItem>
      <FormItem :label="$t('form.bom.setting.bom_type')" prop="bom_type" required :rules="{ required: true, message: 'Bom Type is required.' }">
        <BomTypeSelect v-model="formData.bom_type" value="engineering_bom"></BomTypeSelect>
      </FormItem>
      <FormItem :label="$t('cost.part_cost_form.bom_version')" prop="bom_version">
        <BomVersionSelectByPart v-if="formData.manufacturer_part_id"
                                :bom-type="formData.bom_type"
                                :manufacturer-part-id="formData.manufacturer_part_id"
                                :hasDraft="true"
                                :bomId.sync="formData.bom_id"
                                :versionNumber.sync="formData.bom_version">
        </BomVersionSelectByPart>
      </FormItem>
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('quantity')" prop="quantity" required :rules="{ required: true, message: 'Quantity is required.' }">
            <InputNumber v-model="formData.quantity"></InputNumber>
          </FormItem>
        </Col>
      </Row>
      <Row :gutter="32">
        <Col span="12">
          <FormItem :label="$t('quote.info.currency')" prop="currency" :rules="{ required: true, message: 'Currency is required.' }" required>
            <CurrencySelect v-model="formData.currency"></CurrencySelect>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem :label="$t('exchange_rate')" prop="exchange_rate" :rules="{ required: true, message: 'Exchange rate is required.' }" required>
            <InputNumber v-model="formData.exchange_rate"></InputNumber>
          </FormItem>
        </Col>
      </Row>
      <FormItem class="text-align-right">
        <Button type="primary" @click="handleSave" :loading="saving">{{ $t('save') }}</Button>
      </FormItem>
    </Form>
  </div>
</template>

<script>
import CurrencySelect from '@/components/currency'
import BomVersionSelectByPart from '@/view/bom/versions/bom-versions-select-by-part'
import ManufacturerPartPicker from '@/view/part/components/manufacturer-part-picker'
import BomTypeSelect from '@/view/bom/components/fields/bom-type-select'
import { mapActions } from 'vuex'

export default {
  name: 'AssembledPartCostEstimatorForm',
  components: {
    CurrencySelect,
    BomVersionSelectByPart,
    ManufacturerPartPicker,
    BomTypeSelect
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      saving: false,
      formData: {}
    }
  },
  methods: {
    ...mapActions([
      'createAssembledPartCostEstimator'
    ]),
    handleSave () {
      this.$refs.assembledPartCostEstimatorForm.validate((valid) => {
        if (valid) {
          this.saving = true
          this.createAssembledPartCostEstimator(this.formData).then((resp) => {
            this.$emit('on-saved', resp.data)
          }).finally(() => {
            this.saving = false
          })
        } else {
          this.$Message.error('Please fix errors in the form to continue.')
        }
      })
    }
  },
  watch: {
    data: function () {
      this.formData = _.cloneDeep(this.data)
    }
  }
}
</script>
